// extracted by mini-css-extract-plugin
module.exports = {"statsCard":"Statuses_statsCard__2KfWm"};